<template>
<div>
  <div style="background-color: #F7FAFC; height:100%; width: 100%" class="shadow" v-if="$store.state.showMobileNav">
    <ul class="relative pb-6" style="height: 100%">
      <svg class="absolute" style="top: 10px; right: 15px" @click="$store.commit('showMobileNav', false)"  width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.59 7L12 10.59L8.41 7L7 8.41L10.59 12L7 15.59L8.41 17L12 13.41L15.59 17L17 15.59L13.41 12L17 8.41L15.59 7Z" fill="#10B981"></path>
      </svg>
      <li class="py-3">
        <div class="flex items-center bg-white mx-auto" style="border-radius: 50%; width: 90px; height: 90px">
         <img src="@/assets/logo.svg" alt="logo" class="logo w-full" style="height: 100px">
        </div>
      </li>
      <li class="mt-6 pl-3">
        <div class="flex items-center gap-4">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path :fill="[$route.name === 'Menu' ? '#10B981' : '#2E3A59']" d="M21 21H13V15H21V21ZM11 21H3V11H11V21ZM21 13H13V3H21V13ZM11 9H3V3H11V9Z"></path>
          </svg>
          <router-link to="/app/dashboard/home" class="text-sm ox" :class="[$route.name === 'Menu' ? 'text-base font-bold text-green-500': '']">Dashboard</router-link>
        </div>
      </li>
      <li class="mt-8 pl-3">
        <div class="flex items-center gap-4">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path :fill="[$route.name === 'Approvals' ? '#10B981' : '#2E3A59']" d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C21.9939 17.5203 17.5203 21.9939 12 22ZM11 15V17H13V15H11ZM11 7V13H13V7H11Z"></path>
          </svg>
          <router-link to="/app/dashboard/approvals" class="text-sm ox" :class="[$route.name === 'Approvals' ? 'text-base font-bold text-green-500': '']">Policy approvals</router-link>
        </div>
      </li>
      <li class="mt-8 pl-3">
        <div class="flex items-center gap-4">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path :fill="[$route.name === 'Claims' ? '#10B981' : '#2E3A59']" d="M18 22H6C4.89543 22 4 21.1046 4 20V3.99999C4 2.89542 4.89543 1.99999 6 1.99999H13C13.009 1.99882 13.018 1.99882 13.027 1.99999H13.033C13.0424 2.00294 13.0522 2.00495 13.062 2.00599C13.1502 2.01164 13.2373 2.02878 13.321 2.05699H13.336H13.351H13.363C13.3815 2.06991 13.3988 2.08429 13.415 2.09999C13.5239 2.14841 13.6232 2.21617 13.708 2.29999L19.708 8.29999C19.7918 8.38477 19.8596 8.48404 19.908 8.59299C19.917 8.61499 19.924 8.63599 19.931 8.65899L19.941 8.68699C19.9689 8.77038 19.9854 8.85717 19.99 8.94499C19.9909 8.95495 19.9932 8.96472 19.997 8.97399V8.97999C19.9986 8.98654 19.9996 8.99324 20 8.99999V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22ZM13 3.99999V8.99999H18L13 3.99999Z" ></path>
          </svg>
          <router-link to="/app/dashboard/claims" class="text-sm ox" :class="[$route.name === 'Claims' ? 'text-base font-bold text-green-500': '']">Claim Requests</router-link>
        </div>
      </li>
      <li class="mt-8 pl-3">
        <div class="flex items-center gap-4">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path :fill="[$route.name === 'Cancel' ? '#10B981' : '#2E3A59']" d="M4 19H2C2 15.6863 4.68629 13 8 13C11.3137 13 14 15.6863 14 19H12C12 16.7909 10.2091 15 8 15C5.79086 15 4 16.7909 4 19ZM20.294 15.706L18 13.413L15.707 15.706L14.293 14.292L16.585 12L14.293 9.707L15.707 8.293L18 10.586L20.293 8.293L21.707 9.707L19.414 12L21.707 14.293L20.294 15.706ZM8 12C5.79086 12 4 10.2091 4 8C4 5.79086 5.79086 4 8 4C10.2091 4 12 5.79086 12 8C11.9972 10.208 10.208 11.9972 8 12ZM8 6C6.9074 6.00111 6.01789 6.87885 6.00223 7.97134C5.98658 9.06383 6.85057 9.9667 7.94269 9.99912C9.03481 10.0315 9.95083 9.1815 10 8.09V8.49V8C10 6.89543 9.10457 6 8 6Z"></path>
          </svg>
          <router-link to="/app/dashboard/cancelrequests" class="text-sm ox" :class="[$route.name === 'Cancel' ? 'text-base font-bold text-green-500': '']">Cancel Requests</router-link>
        </div>
      </li>
      <li class="mt-8 pl-3">
        <div class="flex items-center gap-4 cursor-pointer" @click="logout">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 21H10C8.89543 21 8 20.1046 8 19V15H10V19H19V5H10V9H8V5C8 3.89543 8.89543 3 10 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21ZM12 16V13H3V11H12V8L17 12L12 16Z" fill="#2E3A59"></path>
          </svg>
          <p class="text-sm">Logout</p>
        </div>
      </li>
    </ul>
  </div>
  <div v-else class="p-3 shadow flex justify-between lg:hidden">
    <div @click="$store.commit('showMobileNav', true)" class=" gap-2 border-green-500 rounded text-green-500 border p-2 flex">
      <p class="text-sm">Menu</p>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 18H3V16H12V18ZM21 13H3V11H21V13ZM21 8H12V6H21V8Z" fill="#10B981"></path>
      </svg>
    </div>
  </div>
</div>
</template>

<script>
export default {
  data(){
    return {
      showList: false
    }
  },
  methods:{
    logout(){
      this.$store.commit('startLoading')
      this.$store.dispatch('logoutUser')
      .then(()=>{
        this.$router.push('/')
        this.$store.commit('endLoading')
      })
    }
  }

}
</script>

<style scoped>
.switch {
  position: relative;
  display: inline-block;
  width: 32px;
  height: 20px;
}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 15px;
  width: 15px;
  left: 2px;
  bottom: 3px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(13px);
  -ms-transform: translateX(13px);
  transform: translateX(13px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>